<p>resource-report-by-project works!</p>
